// Shared iOS detection + Zoom-app deep link.
//
// The Zoom Meeting SDK for Web cannot use the microphone in any iOS browser
// (Apple does not expose the Audio Worklet API to Safari/WebKit, and every
// iOS browser is forced to use WebKit). So on iPhone/iPad we send users to
// the real Zoom app instead, which they already have installed.

export const isIOS = () =>
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS 13+ reports as Mac; detect touch Macs
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

export const zoomAppLink = (meetingNumber, password) => {
  const mn = String(meetingNumber || '').replace(/\s/g, '');
  const pwd = password ? `&pwd=${encodeURIComponent(password)}` : '';
  return `zoomus://zoom.us/join?confno=${mn}${pwd}`;
};

// Web fallback if the app isn't installed.
export const zoomWebLink = (meetingNumber, password) => {
  const mn = String(meetingNumber || '').replace(/\s/g, '');
  const pwd = password ? `?pwd=${encodeURIComponent(password)}` : '';
  return `https://zoom.us/j/${mn}${pwd}`;
};
